import { createAction } from '@reduxjs/toolkit'
import { ActionNames } from '_constants'

export const uiActions = {
    saveScroll: createAction(ActionNames.SAVE_SCROLL),
    changeRoute: createAction(ActionNames.CHANGE_ROUTE),
}
